import { combineReducers } from "redux";
import uploadReducer from "./uploadReducer";
import fetchReducer from "./fetchReducer";
import newReportReducer from "./newReportReducer";
import { uploadXmlZipFileReducer } from "./uploadXmlZipFileReducer";

const rootReducer = combineReducers({
  upload: uploadReducer,
  fetch: fetchReducer,
  newReportReducer: newReportReducer,
  uploadXmlZipFileReducer: uploadXmlZipFileReducer,
});

export default rootReducer;
